import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDevice } from './useDevice';
import DrawingCanvas from './DrawingCanvas';
import Welcome from './desktop/Welcome';

function Root({ canvasProps, subject }) {
  const { isDesktop, isTablet } = useDevice();
  const [searchParams] = useSearchParams();
  const canvasForced = searchParams.get('canvas') === '1';

  if ((isDesktop || isTablet) && !canvasForced) {
    return <Welcome subject={subject} />;
  }
  return <DrawingCanvas {...canvasProps} />;
}

export default Root;
